export default __webpack_public_path__ + "static/media/search-user-black.300a9534.svg";